// 判断是否是微信客户端
export const isWeixin = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/MicroMessenger/i.test(ua)) {
    return true
  } else {
    return false
  }
}

// 判定来源
export const sourceType = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/MicroMessenger/i.test(ua)) {
    if (/iphone/i.test(ua)) {
      return 'wx_iOS'
    } else if (/android/i.test(ua)) {
      return 'wx_Android'
    }
  } else {
    if (/iphone/i.test(ua)) {
      return 'web_iOS'
    } else if (/android/i.test(ua)) {
      return 'web_Android'
    }
  }
}

// 存储localStorage
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

// 获取localStorage
export const getStore = (name) => {
  if (!name || !window.localStorage.getItem(name)) {
    return ''
  }

  return JSON.parse(window.localStorage.getItem(name))
}

// 删除localStorage
export const removeStore = (name) => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * @param {function} func 需要执行的函数
 * @param {number} wait 等待的时间 毫秒
 * @param {boolean} immediate (defult:false) 默认 代表是否第一次调用立即执行。
 * @description 防抖函数
 */
export const _debounce = (func, wait, immediate) => {
  let timer = null
  let context, args, result, timestamp

  let later = () => {
    let oDate = new Date()
    let last = oDate.getTime() - timestamp
    if (last < wait && last >= 0) {
      timer = setTimeout(later, wait - last)
    } else {
      timer = null
      if (!immediate) {
        result = func.apply(context, args)
        if (!timer) context = args = null
      }
    }
  }

  return function () {
    let oDate = new Date()
    let callNow = immediate && !timer
    timestamp = oDate.getTime()
    context = this
    args = arguments
    if (!timer) {
      timer = setTimeout(later, wait)
    }

    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

// second 等待秒数
export function sleep(second) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('promise resolved')
    }, second * 1000)
  })
}

// 美化时间
export const goodTime = (str) => {
  let now = new Date().getTime()
  let oldTime = new Date(str).getTime()
  let difference = now - oldTime
  let result = ''
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  // let halfamonth = day * 15
  let month = day * 30
  let year = month * 12

  let _year = difference / year
  let _month = difference / month
  let _week = difference / (7 * day)
  let _day = difference / day
  let _hour = difference / hour
  let _min = difference / minute

  if (_year >= 1) {
    result = ~~_year + ' 年前'
  } else if (_month >= 1) {
    result = ~~_month + ' 个月前'
  } else if (_week >= 1) {
    result = ~~_week + ' 周前'
  } else if (_day >= 1) {
    result = ~~_day + ' 天前'
  } else if (_hour >= 1) {
    result = ~~_hour + ' 个小时前'
  } else if (_min >= 1) {
    result = ~~_min + ' 分钟前'
  } else result = '刚刚'
  return result
}

// 格式化日期
export const formatTime = (t, fmt) => {
  if (!t) return undefined
  let time = new Date(t)
  let o = {
    'M+': time.getMonth() + 1, // 月份
    'd+': time.getDate(), // 日
    'h+': time.getHours() % 12 === 0 ? 12 : time.getHours() % 12, // 小时
    'H+': time.getHours(), // 小时
    'm+': time.getMinutes(), // 分
    's+': time.getSeconds(), // 秒
    'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
    S: time.getMilliseconds() // 毫秒
  }
  let week = {
    0: '天',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '星期' : '周') : '') + week[time.getDay() + ''])
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return fmt
}

// 表单用到的正则
export const regExp = {
  // 手机号不正确就返回  false
  mobile: (str) => {
    return Boolean(/^1[3456789]\d{9}$/.test(str))
  },

  // 正整数(非正整数返回true)
  signlessInt: function (str) {
    return !/^[1-9]\d*$/.test(str)
  },

  // 非身份证号(非身份证号返回true)
  idCard: function (str) {
    let _true = true

    if (str.length !== 18) {
      return _true
    } else {
      let numArr = str.split('')
      let modulusArr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      let parallelArr = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
      let _num = 0

      for (let i = 0; i < 17; i++) {
        _num += numArr[i] * modulusArr[i]
      }
      return parallelArr[_num % 11] != numArr[17] ? _true : false
    }
  }
}

// url QueryStr
export const GetQueryString = (name) => {
  let after = window.location.href.split('?')[1]
  if (after) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = after.match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    } else {
      return null
    }
  }
}

// url 转码
export const urlencode = (str) => {
  return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+')
}

export const urldecode = (str) => {
  return decodeURIComponent(str).replace(/ /g, '+')
}

// 是否是m3u8视频
export const isM3U8 = (url) => {
  // let videoUrl = liveInfo.playBackUrl || ''
  if (url && url.length > 4) {
    let lowUrl = url.toLowerCase()
    if (lowUrl.indexOf('.m3u8') != -1) {
      return true
    }
  }
  return false
}

/**
 * 验证 url
 */
export const useValidateUrl = (url) => {
  return /^(http(s)?:\/\/)?([\w.-]+(?:\.[\w\\.-]+)|\w+:\d+)+[\w\-\\._~:/?#[\]@!\\$&'\\*\\+,;=\\?%\-&_~`@[\]\\':+!]*([^<>\\"\\"])]*]*$/.test(url)
}
